module.exports = __webpack_public_path__ + "img/article_9_4.f3cebafa.png";